module.exports = __webpack_public_path__ + "media/images/studio-dda3ef7086e9fca2f78242a2c3493afa.jpg";